import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Timestamp from '../../../Timestamp';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import { styleFromWidthHeight, TextDumboType, getTextDumboTypeBySize, getDeviationTitle, } from '../../_helpers';
import s from './Journal.scss';
var JournalDumbView = function (_a) {
    var deviation = _a.deviation, className = _a.className, useTextlessMode = _a.useTextlessMode, width = _a.width, height = _a.height, _b = _a.responsive, responsive = _b === void 0 ? true : _b, ariaHidden = _a["aria-hidden"];
    var t = useTranslation().t;
    // we need to show image background on full height for Micro and Nano thumbs
    var type = getTextDumboTypeBySize(height || width);
    var isMicroOrNano = [TextDumboType.MICRO, TextDumboType.NANO].includes(type);
    var isWayTooTinyForAnySense = type === TextDumboType.ANTFART;
    var coverImageAttributes = getCoverImageAttributes({
        deviation: deviation,
        width: width,
        height: height,
    });
    var style = styleFromWidthHeight({ width: width, height: height }, responsive);
    var rootStyle = isMicroOrNano && coverImageAttributes
        ? __assign(__assign({}, style), coverImageAttributes.style) : style;
    var headerAttributes = !isMicroOrNano && !isWayTooTinyForAnySense ? coverImageAttributes : {};
    return (React.createElement(Section, { className: classnames(s['root'], s[type], useTextlessMode && s['default-bg'], className), style: rootStyle, "aria-hidden": ariaHidden }, !useTextlessMode && (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({ className: s['header'] }, headerAttributes),
            React.createElement(Heading, { className: s['title'] },
                !deviation.isPublished && (React.createElement("div", { className: s['draft'] }, t('writer.status.draft'))),
                getDeviationTitle(deviation))),
        React.createElement("div", { className: s['body'] },
            React.createElement("div", { className: s['date'] },
                React.createElement(Timestamp, { timestamp: deviation.publishedTime })),
            React.createElement(ExcerptRenderer, { className: s['text'], textContent: deviation.textContent, htmlExcerptLegacy: true }))))));
};
JournalDumbView.displayName = 'JournalDumbView';
export default JournalDumbView;
//# sourceMappingURL=Journal.js.map